import React from 'react';
export const useScrollLock = () => {
  const lockScroll = React.useCallback(() => {
    document.body.classList.add('max-xl:hidden');
  }, []);

  const unlockScroll = React.useCallback(() => {
    document.body.classList.remove('max-xl:hidden');
  }, []);

  return {
    lockScroll,
    unlockScroll,
  };
};
